export function formatPhone(phone: string): string {
  /*

        Tamanho correto de telefone: 12
        Formato: 55 83 123456789

        Telefones de tamanho abaixo de 10 estão faltando o DDD, impossível de arrumar

        Para telefones de tamanho 10: adicionar 55
        Para telefones de tamanho 11: remover o 9 e adicionar 55
        Para telefones de tamanho 13: remover o 9

        formato de telefones de tamanho 10:
        DDD + número

        formato de telefones de tamanho 11:
        DDD + 9 + número  

        formato de telefones de tamanho 13:
        55 + DDD + 9 + número        

      */

   // Remove todos os caracteres que não são números
   phone = phone.replace(/\D/g, "").trim();

   // Verifica se o telefone possui pelo menos 12 dígitos (55 + DDD + número)
   if (phone.length < 12) {
     throw new Error("O telefone informado é inválido, faltando o código do país, DDD ou parte do número: " + phone);
   }
 
   // Verifica se começa com o código do país "55"
   if (!phone.startsWith("55")) {
     throw new Error("O telefone informado não possui o código do país '55': " + phone);
   }
 
   // Remove o código do país "55" para as próximas validações
   phone = phone.slice(2);
 
   // Verifica se o DDD começa com '0' e remove-o, se necessário
   if (phone.startsWith("0")) {
     phone = phone.slice(1);
   }
 
   // Verifica se o DDD possui 2 dígitos
   const ddd = phone.slice(0, 2);
   if (ddd.length !== 2) {
     throw new Error("O DDD do telefone informado é inválido: " + phone);
   }
 
   // Remove o DDD para trabalhar com o número principal
   phone = phone.slice(2);
 
   // Verifica o comprimento do número após o DDD
   if (phone.length === 8) {
     // Se tiver exatamente 8 dígitos, está correto
     return "55" + ddd + phone;
   } else if (phone.length > 8) {
     // Se tiver mais de 8 dígitos, verifica se o primeiro dígito é '9'
     if (phone.startsWith("9")) {
       phone = phone.slice(1); // Remove o '9' extra
     }
   }
 
   // Após o ajuste, o número deve ter exatamente 8 dígitos
   if (phone.length !== 8) {
     throw new Error("O número de telefone após o DDD deve ter 8 dígitos: " + phone);
   }

   let telefoneFormatado = "55" + ddd + phone;
 
   // Retorna o número formatado no formato final 55 + DDD + número de 8 dígitos
   return telefoneFormatado;
}

